import cn from "classnames";
import skeletonStyles from "../styles.module.scss";
import { WIDTHS, HEIGHTS } from "./constants";
import { SkeletonLineProps } from "./types";
import skeletonLineStyles from "./styles.module.scss";

export const SkeletonLine = ({
  className,
  width = WIDTHS.SMALL,
  height = HEIGHTS.SMALL,
  dataTestId = "skeleton-line",
}: SkeletonLineProps) => (
  <div
    className={cn(
      skeletonStyles.skeleton,
      skeletonLineStyles[`width-${width}`],
      skeletonLineStyles[`height-${height}`],
      className
    )}
    data-test-id={dataTestId}
  />
);
